// ActionHistoryTab — placeholder for audit log tab.
// Uses the shared ComingSoonTab pattern.

import { ComingSoonTab } from '@/pages/risks/ComingSoonTab'

export function ActionHistoryTab() {
  return <ComingSoonTab title="Audit Log" />
}
